export default __webpack_public_path__ + "static/media/HDW_Logo_BLK_Background.6919cced.jpg";